class AbortControllerManager {
  controllers = {};

  getSignal(requestName) {
    if (!this.controllers[requestName]) {
      this.controllers[requestName] = new AbortController();
    }

    return this.controllers[requestName].signal;
  }

  abortRequest(requestName) {
    if (this.controllers[requestName]) {
      this.controllers[requestName].abort();
      this.controllers[requestName] = new AbortController(); // Reset for future use
    }
  }
}

export const abortControllerManager = new AbortControllerManager();
